<!-- eslint-disable max-len-->
<template>
  <div class="footer-awards">
    <div class="footer-awards__item">
      <a
        target="_blank"
        href="https://www.goodfirms.co/company/bliss-applications"
      >
        <img
          class="footer-awards__image"
          src="https://assets.goodfirms.co/badges/normal-badge/app-development.svg"
          alt="GoodFirms Badge"
        >
      </a>
    </div>
    <div class="footer-awards__item">
      <a
        target="_blank"
        href="https://www.topdevelopers.co/directory/mobile-app-development-companies"
      >
        <img
          class="footer-awards__image"
          src="https://www.topdevelopers.co/assets/badges/app-2021/Mobile-App/Global/Badge-Top-Mobile-App-Development-Companies-2021.png"
          alt="Mobile App Development Companies"
          title="Mobile App Development Companies"
        >
      </a>
    </div>
    <div class="footer-awards__item">
      <a
        target="_blank"
        href="https://techreviewer.co/top-software-development-companies/"
      >
        <img
          class="footer-awards__image"
          src="https://uploads-ssl.webflow.com/5e455d4bcdc92acda84070ff/5f0de38b60be1d8daadcd848_badge_techreviewer-software_developers-2020.svg"
          alt="Techreviewer badge"
        >
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterAwards'
};
</script>

<style lang="scss" src="@/assets/components/footer/footer-awards-view.scss"></style>



// WEBPACK FOOTER //
// footer-awards-view.vue